import codeTableApi from '../../../api/hr/codeTable'
import { cutTime } from '../../../utils/datetimeUtil'
// initial state
const state = {
  careers: [],
  categories: [],
  categoryScales: [],
  languageTypes: [],
  officialTypes: [],
  pubHolidays: [],
  simplePubHolidays: [],
  subunits: [],
  vinculumTypes: [],
  relativeTypes: []
  // writeSpeakLevels: [],
  // cantOfficialRecognizedLevels: [],
  // mandOfficialRecognizedLevels: [],
  // portOfficialRecognizedLevels: [],
  // engOfficialRecognizedLevels: []
  // educationLevelTypes: [],
  // languageLevelTypes: [],
}

// getters
const getters = {
  getCategoryById: (state, getters) => (id) => {
    if (state.categories.length > 0) {
      return state.categories.find(category => category.id === id)
    }
  },

  getCategoryScaleById: (state, getters) => (id) => {
    if (state.categoryScales.length > 0) {
      return state.categoryScales.find(cs => cs.id === id)
    }
  },

  getSubunitEntityById: (state, getters) => (id) => {
    if (state.subunits.length > 0) {
      return state.subunits.find(subnit => subnit.id === id)
    }
  },

  getVinculumTypeById: (state, getters) => (id) => {
    if (state.vinculumTypes.length > 0) {
      return state.vinculumTypes.find(vt => vt.id === id)
    }
  }

}

// actions
const actions = {
  getCareers ({ commit }) {
    return new Promise((resolve, reject) => {
      codeTableApi.getCareers(careers => {
        commit('setCareers', careers)
        resolve()
      })
    })
  },

  getCategories ({ commit }, careerId) {
    return new Promise((resolve, reject) => {
      codeTableApi.getCategories(categories => {
        commit('setCategories', categories)
        resolve()
      }, careerId)
    })
  },

  getCategoryScales ({ commit }, categoryId) {
    return new Promise((resolve, reject) => {
      codeTableApi.getCategoryScales(categoryScales => {
        commit('setCategoryScales', categoryScales)
        resolve()
      }, categoryId)
    })
  },

  // getEducationLevelTypes ({ commit }) {
  //   codeTableApi.getEducationLevelTypes(educationLevelTypes => {
  //     commit('setEducationLevelTypes', educationLevelTypes)
  //   })
  // },

  // getLanguageLevelTypes ({ commit }) {
  //   codeTableApi.getLanguageLevelTypes(languageLevelTypes => {
  //     commit('setLanguageLevelTypes', languageLevelTypes)
  //   })
  // },

  // getLanguageTypes ({ commit }) {
  //   codeTableApi.getLanguageTypes(languageTypes => {
  //     commit('setLanguageTypes', languageTypes)
  //   })
  // },

  getOfficialTypes ({ commit }, entityId) {
    return new Promise((resolve, reject) => {
      codeTableApi.getOfficialTypesByEntityId(officialTypes => {
        if (officialTypes && officialTypes.length > 0) {
          commit('setOfficialTypes', officialTypes)
          resolve()
        } else {
          codeTableApi.getOfficialTypes(officialTypes => {
            commit('setOfficialTypes', officialTypes)
            resolve()
          })
        }
      }, entityId)
    })
  },

  getPubHolidays ({ commit }) {
    return new Promise((resolve, reject) => {
      if (state.pubHolidays.length < 1) {
        codeTableApi.getPubHolidays(pubHolidays => {
          commit('setPubHolidays', pubHolidays)
          commit('setSimplePubHolidays', pubHolidays)
          resolve()
        })
      }
    })
  },

  getSubunits ({ commit }, entityId) {
    return new Promise((resolve, reject) => {
      codeTableApi.getSubunits(subunits => {
        commit('setSubunits', subunits)
        resolve()
      }, entityId)
    })
  },

  getVinculumTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      codeTableApi.getVinculumTypes(vinculumTypes => {
        commit('setVinculumTypes', vinculumTypes)
        resolve()
      })
    })
  },

  getRelativeTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      codeTableApi.getRelativeTypes(types => {
        commit('setRelativeTypes', types)
        resolve()
      })
    })
  }

  // getCantOfficialRecognizedLevels ({ commit }) {
  //   codeTableApi.getLanguageLevelTypes(cantOfficialRecognizedLevels => {
  //     commit('setCantOfficialRecognizedLevels', cantOfficialRecognizedLevels)
  //     commit('setWriteSpeakLevels', cantOfficialRecognizedLevels)
  //   }, 1)
  // },

  // getMandOfficialRecognizedLevels ({ commit }) {
  //   codeTableApi.getLanguageLevelTypes(mandOfficialRecognizedLevels => {
  //     commit('setMandOfficialRecognizedLevels', mandOfficialRecognizedLevels)
  //   }, 2)
  // },

  // getPortOfficialRecognizedLevels ({ commit }) {
  //   codeTableApi.getLanguageLevelTypes(portOfficialRecognizedLevels => {
  //     commit('setPortOfficialRecognizedLevels', portOfficialRecognizedLevels)
  //   }, 3)
  // },

  // getEngOfficialRecognizedLevels ({ commit }) {
  //   codeTableApi.getLanguageLevelTypes(engOfficialRecognizedLevels => {
  //     commit('setEngOfficialRecognizedLevels', engOfficialRecognizedLevels)
  //   }, 4)
  // }

//   getCourse ({ commit, state }, cid) {
//     // console.log('getCourse: ' + payload.cid)
//     const course = state.all.find(course => course.id === ~~cid)
//     commit('setCourse', course)
//   }
}

// mutations
const mutations = {
  setCareers (state, careers) {
    state.careers = careers
  },

  setCategories (state, categories) {
    state.categories = categories
  },

  setCategoryScales (state, categoryScales) {
    state.categoryScales = categoryScales
  },

  // setEducationLevelTypes (state, educationLevelTypes) {
  //   state.educationLevelTypes = educationLevelTypes
  // },

  // setLanguageLevelTypes (state, languageLevelTypes) {
  //   state.languageLevelTypes = languageLevelTypes
  // },

  // setLanguageTypes (state, languageTypes) {
  //   state.languageTypes = languageTypes
  // },

  setOfficialTypes (state, officialTypes) {
    state.officialTypes = officialTypes
  },

  setPubHolidays (state, pubHolidays) {
    state.pubHolidays = pubHolidays
  },

  setSimplePubHolidays (state, pubHolidays) {
    state.simplePubHolidays = pubHolidays.map(h => {
      return cutTime(h.holidayDate)
    })
  },

  setSubunits (state, subunits) {
    state.subunits = subunits
  },

  setVinculumTypes (state, vinculumTypes) {
    state.vinculumTypes = vinculumTypes
  },

  setRelativeTypes (state, types) {
    let tempTypes = types.filter(type => type.absentTypeId != null)
    tempTypes.sort((a, b) => a.listOrder - b.listOrder)
    state.relativeTypes = tempTypes
  }

  // setWriteSpeakLevels (state, writeSpeakLevels) {
  //   state.writeSpeakLevels = writeSpeakLevels
  // },

  // setCantOfficialRecognizedLevels (state, cantOfficialRecognizedLevels) {
  //   state.cantOfficialRecognizedLevels = cantOfficialRecognizedLevels
  // },

  // setMandOfficialRecognizedLevels (state, mandOfficialRecognizedLevels) {
  //   state.mandOfficialRecognizedLevels = mandOfficialRecognizedLevels
  // },

  // setPortOfficialRecognizedLevels (state, portOfficialRecognizedLevels) {
  //   state.portOfficialRecognizedLevels = portOfficialRecognizedLevels
  // },

  // setEngOfficialRecognizedLevels (state, engOfficialRecognizedLevels) {
  //   state.engOfficialRecognizedLevels = engOfficialRecognizedLevels
  // }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
